/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamCollectionAliases {
  AVATAR_EC = 'avatar-ec',
  CONFIRM_EXAM_COLLECTION_UNLABELLED = 'confirm-exam-collection-unlabelled',
  CONFIRM_EXAM_COLLECTION_UNLABELLED_FRAGMENT = 'confirm-exam-collection-unlabelled-fragment',
  EC_MAIN_APPLICATION = 'ec-main-application',
  EC_PATIENT_CONFIRMATION = 'ec-patient-confirmation',
  EC_PATIENT_CONFIRMATION_FRAGMENT = 'ec-patient-confirmation-fragment',
  EXAM_COLLECT_ENCOUNTER_PATIENT_DETAILS = 'exam-collect-encounter-patient-details',
  EXAM_COLLECT_ENCOUNTER_PATIENT_DETAILS_FRAGMENT = 'exam-collect-encounter-patient-details-fragment',
  EXAM_COLLECT_GENERATE_TAG_DATA = 'exam-collect-generate-tag-data',
  EXAM_COLLECT_GENERATETAG_DATA_FRAGMENT = 'exam-collect-generatetag-data-fragment',
  EXAM_PENDING_EXAM_COLLECTION = 'exam-pending-exam-collection',
  EXAM_PENDING_EXAM_COLLECTION_FRAGMENT = 'exam-pending-exam-collection-fragment',
  MAIN_LAYOUT = 'main-layout',
  MEDICAL_PRESCRIPTIONS_LIST = 'medical-prescriptions-list',
  MEDICAL_PRESCRIPTIONS_LIST_FRAGMENT = 'medical-prescriptions-list-fragment',
  PANEL_RESOLUTION = 'panel-resolution',
  PATIENT_LIST = 'patient-list',
  PATIENT_LIST_FRAGMENT = 'patient-list-fragment',
  SEARCH_PATIENT = 'search-patient',
  SEARCH_PATIENT_FRAGMENT = 'search-patient-fragment',
  TEXT_RESOLUTION_SUPORTED = 'text-resolution-suported',
}
export { ExamCollectionAliases };
